import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';
import type { Port } from './usePorts';

export type AdminPort = Port;

export const useAdminPorts = () => {
  const qc = useQueryClient();

  const list = useQuery({
    queryKey: ['admin-ports'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('ports' as any)
        .select('*')
        .order('nom', { ascending: true });
      if (error) throw error;
      return (data as any) as AdminPort[];
    },
  });

  const create = useMutation({
    mutationFn: async (payload: Partial<AdminPort>) => {
      const { error } = await supabase.from('ports' as any).insert(payload as any);
      if (error) throw error;
    },
    onSuccess: () => {
      toast.success('Port créé');
      qc.invalidateQueries({ queryKey: ['admin-ports'] });
    },
    onError: (e: any) => toast.error(e.message || 'Erreur création port'),
  });

  const update = useMutation({
    mutationFn: async ({ id, ...payload }: Partial<AdminPort> & { id: string }) => {
      const { error } = await supabase.from('ports' as any).update(payload as any).eq('id', id);
      if (error) throw error;
    },
    onSuccess: () => {
      toast.success('Port mis à jour');
      qc.invalidateQueries({ queryKey: ['admin-ports'] });
    },
    onError: (e: any) => toast.error(e.message || 'Erreur mise à jour'),
  });

  const remove = useMutation({
    mutationFn: async (id: string) => {
      const { error } = await supabase.from('ports' as any).delete().eq('id', id);
      if (error) throw error;
    },
    onSuccess: () => {
      toast.success('Port supprimé');
      qc.invalidateQueries({ queryKey: ['admin-ports'] });
    },
    onError: (e: any) => toast.error(e.message || 'Erreur suppression'),
  });

  return { ...list, create, update, remove };
};
